import React from 'react';
import { TimeInput, TimeInputProps } from '@heroui/react';
import cn from 'classnames';
import { Svg } from '@/shared/ui/Svg';
import ClockIcon from '@/shared/assets/icons/clock.svg';
import styles from './CustomTimeInput.module.scss';

interface CustomTimeInputProps extends Omit<TimeInputProps, 'classNames'> {
  errorMessage?: string;
  showError?: boolean;
}

export const CustomTimeInput = (props: CustomTimeInputProps) => {
  const { errorMessage, showError = false, ...timeInputProps } = props;

  const isInvalid = !!errorMessage;
  const classnamesTimeInput = {
    base: styles.datepickerBase,
    label: cn(styles.datepickerInputLabel, isInvalid ? styles.error : ''),
    inputWrapper: cn(styles.datepickerInputWrapper, isInvalid ? styles.error : ''),
    innerWrapper: styles.innerWrapper,
    input: cn(styles.datepickerText, styles.valueText),
    segment: styles.segment,
    separator: styles.separator,
    helperWrapper: styles.errorMessage,
  };

  return (
    <TimeInput
      {...timeInputProps}
      labelPlacement="outside"
      hourCycle={24}
      endContent={<Svg Icon={ClockIcon} width={20} height={20} className="text-[#acacb4]" />}
      isInvalid={isInvalid}
      errorMessage={showError ? errorMessage : undefined}
      classNames={classnamesTimeInput}
    />
  );
};
